import React from "react"
import styled from "styled-components"

import Typography from "@material-ui/core/Typography"

import HeroImage from "../../HeroImage"
import Textarea from "../../textarea"

// import * as theme from "../../../theme"

const Banner = props => {
  const { image, headline, content } = props
  return (
    <Container>
      {!!image && (
        <Image>
          <HeroImage alt={image.alt} bg={image.url} />
        </Image>
      )}
      {!!headline && <Headline>{headline}</Headline>}
      {!!content && <Textarea content={content} />}
    </Container>
  )
}

export default Banner

const Container = styled.div`
  margin-bottom: 50px;
`
const Image = styled.div`
  position: relative;
  height: 300px;
  margin-bottom: 30px;
  min-height: 160px;
`
const H2 = h2props => <Typography {...h2props} variant="h2" />

const Headline = styled(H2)`
  && {
    margin-bottom: 30px;
  }
`
